import { c as _c } from "react/compiler-runtime";
import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";

// Fixed height to match ProjectBrowserItem
const ITEM_HEIGHT = 76;
export const ProjectBrowserItemSkeleton: React.FC = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      height: ITEM_HEIGHT,
      p: 1.75,
      px: 2,
      borderRadius: 1.5
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box sx={{
      width: 20,
      height: 20,
      flexShrink: 0
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton variant="text" width="60%" height={20} sx={{
      fontSize: "0.95rem"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Stack direction="row" spacing={1.5} alignItems="center" flex={1} minWidth={0}>{t1}<Stack direction="column" spacing={0.5} flex={1} minWidth={0}><Stack direction="row" spacing={1} alignItems="center" flexWrap="nowrap">{t2}<Skeleton variant="rectangular" width={80} height={22} sx={{
            borderRadius: 1
          }} /></Stack></Stack></Stack>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Skeleton variant="rectangular" width={60} height={24} sx={{
      borderRadius: 1.5
    }} />;
    t5 = <Skeleton variant="circular" width={32} height={32} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.5} sx={t0}>{t3}<Stack direction="row" spacing={1} alignItems="center" flexShrink={0}>{t4}{t5}<Skeleton variant="rectangular" width={40} height={18} sx={{
          borderRadius: 0.75
        }} /></Stack></Stack>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};